import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../../services/catalogApi';
import Icon from '../../components/common/Icon/Icon';
import { useLanguage } from '../../context/LanguageContext';

const categories = [
  { form: 'capsules', icon: 'leaf', title: 'Herbal Capsules', description: 'Browse capsule products by name, pack size and MRP.' },
  { form: 'syrup', icon: 'bottle', title: 'Herbal Syrups', description: 'Explore the available syrup range and compare product details.' },
  { form: 'oil', icon: 'drop', title: 'Herbal Oil', description: 'View the available herbal oil with its pack size and MRP.' }
];

function CategoriesPage() {
  const { translate } = useLanguage();
  const [counts, setCounts] = useState({});
  useEffect(() => {
    const controller = new AbortController();
    getProducts({ limit: 48 }, controller.signal).then(({ data }) => {
      setCounts(data.reduce((result, product) => ({ ...result, [product.form]: (result[product.form] || 0) + 1 }), {}));
    }).catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <main className="catalogue-page">
      <header className="catalogue-hero"><div className="container"><p className="eyebrow">{translate('Shop by product form')}</p><h1>{translate('Product Categories')}</h1><p>Categories organise products by how they are supplied. Use Shop to search and compare individual products.</p></div></header>
      <section className="section"><div className="container catalogue-category-grid">{categories.map((category) => <article key={category.form}><span aria-hidden="true"><Icon name={category.icon} /></span><h2>{translate(category.title)}</h2><p>{category.description}</p><strong>{counts[category.form] ?? '—'} {translate('Products')}</strong><Link className="button button--secondary" to={`/shop?form=${category.form}`}>{translate('View products')}</Link></article>)}</div></section>
    </main>
  );
}

export default CategoriesPage;
